import { render, staticRenderFns } from "./NewBranch.vue?vue&type=template&id=ccd243c2&scoped=true&"
import script from "./NewBranch.vue?vue&type=script&lang=js&"
export * from "./NewBranch.vue?vue&type=script&lang=js&"
import style0 from "./NewBranch.vue?vue&type=style&index=0&id=ccd243c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd243c2",
  null
  
)

export default component.exports